export const SERVER_HEARTBEAT_INTERVAL = 30_000
